import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberTitleForm from '../../../components/forms/MemberTitleForm';
import { useMemberTitleById, useUpdateMemberTitle } from '../../../hooks/useMemberTitleApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberTitleDTO } from '../../../services/apiClient';

const MemberTitleEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useMemberTitleById(id!);
  const updateMutation = useUpdateMemberTitle();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Titles', href: '/admin/membertitles' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/membertitles');
    } catch (error) {
      console.error('Error updating MemberTitle:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/membertitles"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.MemberTitle.Edit'
    >
        {entityData ? (
          <MemberTitleForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/membertitles')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default MemberTitleEdit;